import { Injectable, EventEmitter } from '@angular/core';
declare var $: any;

export interface ToastProperties {
  type: 'success' | 'error' | 'warning';
  icon: string;
  title: string;
  message: string;
}

@Injectable({
  providedIn: 'root'
})
export class ToastService {

  private _toastId: string = 'globalToast';
  toastIdChanged = new EventEmitter<string>();
  
  type: string = '';
  icon: string = '';
  title: string = '';
  message: string = '';
  isVisible: boolean = false;
  
  get toastId(): string {
    return this._toastId;
  }
  
  set toastId(value: string) {
    if (this._toastId !== value) {
      this._toastId = value;
      // Emitir el cambio en el próximo ciclo para evitar ExpressionChangedAfterItHasBeenCheckedError
      setTimeout(() => {
        this.toastIdChanged.emit(value);
      }, 0);
    }
  }

  toastProp: ToastProperties[] = [
    { type: 'success', icon: 'fi fi-ss-check-circle success', title: 'Success', message: 'Your changes were saved!' },
    { type: 'error', icon: 'fi fi-ss-cross-circle error', title: 'Oops', message: 'Something went wrong!' },
    { type: 'warning', icon: 'fi fi-ss-triangle-warning warning', title: 'Warning', message: '' },
  ];

  ShowToast(type: 'success' | 'error' | 'warning', message?: string) {

    const p = this.toastProp.find(x => x.type == type);

    this.type = type;
    this.icon = p.icon;
    this.title = p.title;
    this.message = message != null ? message : p.message;
    this.isVisible = true;

    // Auto-ocultar después de 2.3 segundos
    setTimeout(() => { this.HideToast(); }, 2300);
  }

  HideToast() {
    this.isVisible = false;
    
    // Limpiar propiedades después de la animación
    setTimeout(() => {
      this.type = '';
      this.icon = '';
      this.title = '';
      this.message = '';
    }, 300);
    
    // Limpiar cualquier backdrop residual de Bootstrap
    $('.modal-backdrop').remove();
    $('body').removeClass('modal-open').css('padding-right', '');
  }

  /**
   * Limpia todos los toasts y backdrops que puedan estar atascados
   */
  CleanupAllToasts() {
    this.isVisible = false;
    this.type = '';
    this.icon = '';
    this.title = '';
    this.message = '';
    
    // Limpiar cualquier backdrop residual de Bootstrap
    $('.modal-backdrop').remove();
    $('body').removeClass('modal-open').css('padding-right', '');
  }

}
